<template>
  <div class="feedbackBox">
    <v-title title="终端拜访" :isShowBack="true" :isDefaultBack="false" @backHandle="goBack()"></v-title>
    <div class="closeBox">
      <div class="topImg">
        <img :src="successIcon" alt="">
      </div>
      <p class="success-title">拜访信息提交成功</p>
      <button class="btn-item navigation" @click="goCheckRecord()">查看记录</button>
      <button class="btn-item no-phone" @click="backHome">返回首页</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'visitSuccess',
  components: {},
  beforeRouteEnter (to, from, next) {
    console.log(from.name)
    next(vm => vm.setData(from.name))
  },
  data () {
    return {
      fromName: '',
      value: '',
      recordId: null,
      successIcon: require('@/assets/feedback/succeed.png')
    }
  },
  computed: {},
  created () {
    console.log(222, this.$route.query.data)
    this.recordId = this.$route.query.data
  },
  mounted () {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.fun, false)// false阻止默认事件
    }
  },
  destroyed () {
    window.removeEventListener('popstate', this.fun, false)// false阻止默认事件
  },
  methods: {
    setData (name) {
      this.fromName = name
    },
    goCheckRecord () {
      this.$router.push({
        name: 'visitDetail',
        query: {
          data: this.recordId
        }
      })
    },
    goBack () {
      if (this.fromName === 'visitFill') {
        this.$router.push({ name: 'terminalVisitMap' })
      } else if (this.fromName === 'addVisit') {
        this.$router.back()
      } else {
        this.$router.go(-3)
      }
    },
    backHome () {
      this.$router.push({ name: 'index' })
    }
  }
}
</script>

<style lang="stylus" scoped>
    @import "../../stylus/base/base.styl"
    .feedbackBox{
        height 100%
        .closeBox{
            padding 20px
            text-align center
        }
        .topImg{
            display flex
            align-items center
            justify-content center
            img{
                margin-top 50px
                width 80px
                margin-top 50px
                height 80px
            }
        }
        .success-title{
          text-align center
          margin-top 50px
          font-size 36px
          color $color-main
          pading 20px
        }
        .btn-item{
          margin:60px 10px
          width 319px
          height 88px
          border-radius: 8px
          &.navigation{
            text-align: center
            font-size $font-XXXL
            color $color-white
            background $color-main
          }
          &.no-phone{
            border 1px solid $color-main
            font-size $font-XXXL
            color $color-main
          }
        }
    }
</style>
